import * as ReactBootstrap from "react-bootstrap";
import Moment from "react-moment";
import React, { useCallback } from "react";
import { EstimationLineDeleteButton } from "./EstimationLineDeleteButton";
import { EstimationLineProps } from "./types";


const LabeledValue = ({
  label,
  value,
}: {
  label: string;
  value: React.ReactNode;
}) => (
  <div className="mb-2">
    <strong>{label}</strong> {value}
  </div>
);

export const EstimationLine = ({
  ticket,
  part_request,
  onUpdate,
}: EstimationLineProps) => {
  const handleDelete = useCallback(() => {
    onUpdate?.({
      ...ticket,
      quotation_records: ticket.quotation_records.filter(
        (x) => x.url !== part_request.url
      ),
    });
  }, [ticket, part_request.url, onUpdate]);

  return (
    <ReactBootstrap.Card className="mb-2">
      <ReactBootstrap.Card.Body className="p-4">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col className="p-0" xs="6">
            <LabeledValue
              label="Description:"
              value={part_request.description}
            />
            <div className="mb-2 text-muted">
              <small>
                <Moment fromNow>{part_request.created_at}</Moment>
              </small>
            </div>
            <LabeledValue
              label="Part Number:"
              value={part_request.part_number}
            />
            <LabeledValue
              label="Stock Price:"
              value={part_request.stock_price}
            />
            <LabeledValue label="GST:" value={`${part_request.gst} %`} />
            <LabeledValue label="Margin:" value={`${part_request.margin} %`} />
            <LabeledValue
              label="Price to Pay:"
              value={`₹${Number(part_request.final_amount).toLocaleString(
                "en-IN"
              )}`}
            />
          </ReactBootstrap.Col>

          <ReactBootstrap.Col className="text-end p-0" xs="6">
            <EstimationLineDeleteButton
              record={part_request}
              onDelete={handleDelete}
            />
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  );
};
